export const SET_FILTER_FIELD = 'SET_FILTER_FIELD';
export const RESET_FILTER_FORM = 'RESET_FILTER_FORM';
export const SET_ALBUM_FILTER = 'SET_ALBUM_FILTER';
